import OrganizationsTable from './OrganizationsTable';

function SuperAdminOrganizations() {
  return (
    <main className="flex flex-col w-full h-full">
      <h1 className="mb-2 font-bold">Organizations</h1>
      <OrganizationsTable />
    </main>
  );
}

export default SuperAdminOrganizations;
